<template>
    <tip-tap-dropdown>
        <template #button>
            <tip-tap-button
                class="!w-[70px] flex justify-between gap-1"
                :tooltip="lang('fields::fields.wysiwyg.font_size.tooltip')"
            >
                <span class="text-xs truncate">
                    {{ activeFontSize || lang('fields::fields.wysiwyg.font_size.default') }}
                </span>
                <div class="absolute flex flex-col -translate-y-1/2 right-px top-1/2">
                    <icon icon="fa/solid/caret-down" class="w-2 h-2"></icon>
                </div>
            </tip-tap-button>
        </template>
        <template #dropdown="{ close }">
            <ui-popover-section>
                <ui-popover-segment>
                    <div class="overflow-y-auto max-h-[200px]">
                        <ui-popover-link
                            @click="
                                unsetSize();
                                close();
                            "
                        >
                            <span class="text-xs">{{ lang('fields::fields.wysiwyg.font_size.unset') }}</span>
                        </ui-popover-link>
                        <ui-popover-link
                            v-for="size in sizes"
                            :key="size"
                            :active="activeFontSize === size + 'px'"
                            @click="
                                selectSize(size);
                                close();
                            "
                        >
                            <span class="text-xs">{{ size }}px</span>
                        </ui-popover-link>
                    </div>
                </ui-popover-segment>
            </ui-popover-section>
        </template>
    </tip-tap-dropdown>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { Editor } from '@tiptap/vue-3';
import TipTapDropdown from '@src/Fields/Pages/WYSIWYG/TipTap/TipTapDropdown.vue';
import TipTapButton from '@src/Fields/Pages/WYSIWYG/TipTap/TipTapButton.vue';
import Icon from '@src/Common/Components/Icon.vue';

const props = defineProps<{
    editor: Editor;
}>();

const sizes = [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 36, 48, 64, 72];

const activeFontSize = computed(() => {
    return props.editor.getAttributes('textStyle').fontSize || '';
});

const selectSize = (size: number) => {
    props.editor.chain().focus().setFontSize(size + 'px').run();
};

const unsetSize = () => {
    props.editor.chain().focus().unsetFontSize().run();
};
</script>
